import { Link, Outlet, useLoaderData, useLocation, useNavigate, useSearchParams } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import { useAuthStore, User } from "src/components/main/authStore";
import { Fragment } from "react";
import Profile from "src/components/common/Profile";
import ServerFooter from "../common/ServerFooter";
import { MyDate } from "../common/functions";
//--------------------------------------------------------------------------------------------
export const extraFields = ["page", "limit"];
export default function UserList(){
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const curUser = useAuthStore(state => state.user) as User;
    const { users, total } = (useLoaderData() ?? {users: [], total: 0}) as {users: User[], total: number};
    const colorCode = (user:User) => {
        if(user.verificationCode !== null) return "yellow";
        if(user.quitDate && user.quitDate < (new MyDate()).s()) return "lightgray";
    }
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    return(
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <nav className = "d-flex align-items-center mt-2 mb-4">
                <Link children = "Export" className = "btn btn-outline-success me-3" to = {{ pathname: "Export", search: location.search }}/>
                <Link className = {"btn btn-outline-primary me-3 position-relative"} to = {{ pathname: "Filter", search: location.search }}>
                    Filter
                    {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.4em"}}/>:null}
                </Link>
                <Link children = "BirthDay" className = "btn btn-outline-primary me-3" to = {{ pathname: "BirthDay", search: location.search }}/> 
                {curUser.personel === "edit" && <button children = "Add" onClick = {() => navigate(`Add`, {state: { background: location }})} className = "btn btn-outline-primary ms-auto"/>}
            </nav>
            {total === 0?<div children = "No Users yet." className = "alert alert-info text-center"/>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Name</th>
                            <th>Email Address</th>
                            <th>Mobile Phone</th>
                            <th>Work Phone</th>
                            <th>Role</th>
                            <th>Version</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {users.map((user, key) =>
                        <Fragment key = {key}>
                        <tr style = {{backgroundColor: colorCode(user)}} className="inheritTd">
                            <td className = "text-nowrap">
                                {user.profileUrl && <Profile
                                    value = {`${user.profileUrl}?v=${Date.now()}`}
                                    side = {80}
                                />}
                                {user.userName}
                            </td>
                            <td className = "user-select-text">{user.id && <a href = {`mailto:${user.email}`} children = {user.email}/>}</td>
                            <td>{user.phoneNumber && <a href = {`tel:+1${user.phoneNumber}`} children = {user.phoneNumber}/>}</td>
                            <td>
                                {user.workPhone && <a href = {`tel:+1${user.workPhone.replace(/-/g, "")}${user.extension?`,${user.extension}`:""}`}>
                                    {user.workPhone}{user.extension?` Ext. ${user.extension}`:null}
                                </a>}
                            </td>
                            <td>{user.role}</td>
                            <td>{user.version}</td>
                            <td><Link to = {user.id} children = "Detail" className = "btn btn-outline-primary"/></td>
                        </tr>
                        </Fragment>)}
                    </tbody>
                </table>
            </div>}
            {total > 0? <ServerFooter length = {total}/> : null}
            <Outlet/>
        </div>
    )
}